var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FeedbackProvider',{attrs:{"sendingState":_vm.sendingState}},[_c('v-btn',{attrs:{"small":"","color":_vm.color,"elevation":"0","fab":"","disabled":_vm.isDisabled},on:{"mousedown":_vm.down,"mouseup":_vm.up}},[_c('lynus-icon',{attrs:{"name":_vm.icon,"size":"24","color":"white"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }